import Axios from '@/api/http'

/**
 * 单选关联控件搜索
 * */
export function apiGetreportdatalist(query) {
  return Axios({
    method: 'post',
    url: '/api/getreportdatalist',
    data: query
  })
}
